import gql from 'graphql-tag';
// import { FRAGMENT_CTA_BUTTON } from 'src/modules/global';
export const FRAGMENT_FULL_HERO = gql`
  fragment fullHero on ComponentTextImageFullWidthHero {
    title_en
    subline_en
    title_de
    subline_de
    button {
      text_en
      text_de
      url
      external_link
      isButton: button
      overlay
      download {
        url
      }
    }
    image {
      url
      caption
    }
    mobile_image {
      url
      caption
    }
  }
`;
